import "./TrafficLight.css";

type LightProps = {
  backgroundColor?: string;
};

function Light({ backgroundColor }: LightProps) {
  return (
    <div
      aria-hidden={true}
      className="traffic-light"
      style={{ backgroundColor }}
    />
  );
}

type Config = {
  [key: string]: {
    backgroundColor: string;
  };
};

type TrafficLightProps = {
  initialColor?: string;
  config: Config;
  layout?: "vertical" | "horizontal";
};

export default function TrafficLight({
  initialColor = "green",
  config,
  layout = "vertical",
}: TrafficLightProps) {
  return (
    <div
      aria-live="polite"
      aria-label={`Current light: ${initialColor}`}
      className={[
        "traffic-light-container",
        layout === "vertical" && "traffic-light-container--vertical",
      ]
        .filter((cls) => !!cls)
        .join(" ")}
    >
      {Object.keys(config).map((color) => (
        <Light
          key={color}
          backgroundColor={
            color === initialColor ? config[color].backgroundColor : undefined
          }
        />
      ))}
    </div>
  );
}
